export class CaseViewEvent {
  id: number;
  timestamp: string;
  summary: string;
  comment: string;
  event_id: string;
  event_name: string;
  state_id: string;
  state_name: string;
  user_id: number;
  user_last_name: string;
  user_first_name: string;
  significant_item: {
    type: string,
    description: string,
    url: string
  };
}
